<template>
    <div>
      <QrCodeReader
        v-if="isCameraEnabled"
        @on-detect="onReadQrCode"
        class="mx-auto mb-14 h-[185px] w-[185px]"
      />
  
      <TextInput
        type="number"
        ref="input"
        class="mb-8 w-full"
        :class="{
          'mt-36': !isCameraEnabled
        }"
        label="Informe o código do Produto"
        @enter-key-up="handleClickSubmitButton"
        v-model="productCode"
      />
  
      <VButton :disabled="!productCode" type="solid" title="Enviar" :callback="handleClickSubmitButton" />
    </div>
  </template>
  
  <script setup lang="ts">
  import VButton from '@/components/Button/VButton.vue'
  import QrCodeReader from '@/components/QrCodeReader/QrCodeReader.vue'
  import TextInput from '@/components/TextInput/TextInput.vue'
  import { showDefaultToast } from '@/helpers/toast-models'
  import { extractTagFromUrl } from '@/helpers/url-parser'
  import { ScanInputType, useAppStore } from '@/stores/app.store'
  import { computed, onMounted, ref, watch } from 'vue'
  import { useFetchProduct } from './query'
  
  const appStore = useAppStore()
  
  const productCode = ref('')
  
  const { data, refetch: fetchProduct, isError } = useFetchProduct(productCode)
  
  const input = ref<HTMLInputElement | null>(null)
  
  const isCameraEnabled = computed(() => appStore.scanInputType === ScanInputType.CAMERA)
  
  async function onReadQrCode(code: string) {
    input.value?.focus()
    const product = extractTagFromUrl(code)
  
    if (product) {
      productCode.value = product
      await handleClickSubmitButton()
      return
    }
  
    showDefaultToast('Código inválido', "error")
  }
  
  async function handleClickSubmitButton() {
    await fetchProduct()
  
    if (data.value && !isError.value) {
      appStore.actions.setCurrentReadProduct({
        description: data.value.description,
        size: data.value.size,
        year: data.value.year,
        primaryColorHex: data.value.primaryColorHex,
        secondaryColorHex: data.value.secondaryColorHex,
        serialNumber: data.value.serialNumber,
        loadedAt: data.value.loadedAt
      })
      appStore.actions.setCurrentTagReadProduct(productCode.value)
    }
  }
  
  function autoFocus() {
    if (appStore.scanInputType === ScanInputType.EXTERNAL_SENSOR) {
      input.value?.focus()
    }
  }
  
  onMounted(autoFocus)
  
  watch(() => appStore.scanInputType, autoFocus)
  </script>